import DateFormat from '@/shared/utils/date-format';
import FilterUtils from '@/shared/utils/filters';

export default class CancelItemRuleRequest {
  contractItemRuleId: string;

  billingStrategy: string;

  billingValue: string;

  description: string;

  name: string;

  value: string = '0';

  constructor(obj: any = {}) {
    this.contractItemRuleId = obj.contractItemRuleId || '';
    this.billingStrategy = obj.billingStrategy || '';
    this.billingValue = obj.billingValue || '';
    this.description = obj.description || '';
    this.name = obj.name || '';
  }

  public static of(obj: any = {}): CancelItemRuleRequest {
    return new CancelItemRuleRequest(obj || {});
  }

  public static ofList(obj: any[]): CancelItemRuleRequest[] {
    return obj.map(this.of);
  }

  handleValue() {
    this.billingValue = FilterUtils.formatValue(this.value)
  }
}
